import * as CL from '@design-system/component-library';
import { Grid } from '../Grid/Grid';
import { pictureStorageBaseUrl } from '../Picture/contentfulImageProxy';
import type { PropsWithChildren, ReactNode } from 'react';

import './DetailsWithInfoColumn.scss';

export type DetailsWithCardProps = PropsWithChildren<{
  cardId?: string;
  cardImage?: string;
  cardPicto?: string;
  cardContent: ReactNode;
  disclaimerContent?: ReactNode;
}>;

export type DetailsWithInfoColumnProps = PropsWithChildren<{
  infoColumnContent?: ReactNode;
  disclaimerContent?: ReactNode;
}>;

export const DetailsWithInfoColumn = ({
  children,
  infoColumnContent,
  disclaimerContent,
}: DetailsWithInfoColumnProps) => (
  <div className="of-page-margins--as-margin">
    {disclaimerContent}
    <Grid>
      <div className="of-details-with-info-column">
        <div className="of-details-with-info-column__details">{children}</div>
        <div className="of-details-with-info-column__info-column">{infoColumnContent}</div>
      </div>
    </Grid>
  </div>
);

const CardHeading = ({ cardImage, cardPicto }: { cardImage?: string; cardPicto?: string }) => {
  if (cardImage) {
    return <img alt="" src={`${pictureStorageBaseUrl}${cardImage}`} />;
  }
  if (cardPicto) {
    return <div className={`picto picto-${cardPicto}`} />;
  }
  return undefined;
};

export const DetailsWithCard = ({
  children,
  cardId,
  cardImage,
  cardPicto,
  cardContent,
  disclaimerContent,
}: DetailsWithCardProps) => (
  <DetailsWithInfoColumn
    infoColumnContent={
      <CL.Card
        id={cardId}
        heading={CardHeading({ cardImage, cardPicto })}
        content={cardContent}
        type="dark"
        analytics-parent-element="OmaElisa instruction card"
      />
    }
    disclaimerContent={disclaimerContent}
  >
    {children}
  </DetailsWithInfoColumn>
);
